import { render, staticRenderFns } from "./SolicitudesGenerales.vue?vue&type=template&id=67e96429"
import script from "./SolicitudesGenerales.vue?vue&type=script&lang=js"
export * from "./SolicitudesGenerales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports